import React from 'react';
import { Influencer } from '../types/client';

const InfluencerContext = React.createContext<Influencer | null>(null);

export default InfluencerContext;
